import ApiClientOpen from "../api/axios/apiClientOpen"

export const planes =  async ()=>{

        const planes = await ApiClientOpen.get('/planes', {
            params: {
                'sort[0]': 'precioMensual:asc'
            }
        })
        return planes.data.data;        

}